export const useVentilationSubmit = () => {
  const onSubmit = (data: any) => {
    // Handle form submission logic here
    console.log('Ventilation form submitted with data:', data);
  };

  return { onSubmit };
};
